var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',_vm._l((_vm.daDataList),function(daData){return _c('b-row',{key:daData.title},[_c('b-col',{attrs:{"cols":"12"}},[_c('data-availability',{attrs:{"uniqueName":daData.uniqueKey,"data":daData.data,"title":daData.title}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }